import { render, staticRenderFns } from "./AddEditAppearance.vue?vue&type=template&id=1045f321&scoped=true"
import script from "./AddEditAppearance.vue?vue&type=script&lang=js"
export * from "./AddEditAppearance.vue?vue&type=script&lang=js"
import style0 from "./AddEditAppearance.vue?vue&type=style&index=0&id=1045f321&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1045f321",
  null
  
)

export default component.exports